import { MessageSeverity } from '../services/message.service';

export interface BroadcastEvent {
  getName(): string;
}

export class MessageEvent implements BroadcastEvent {

  public static NAME = 'MessageEvent';

  constructor(
    private severity: MessageSeverity,
    private messageKey: string,
    private messageParams?: any[]) { }

  getName(): string {
    return MessageEvent.NAME;
  }


  getSeverity(): MessageSeverity {
    return this.severity;
  }

  getMessageKey(): string {
    return this.messageKey;
  }

  getMessageParams(): any[] {
    return this.messageParams;
  }

}
